var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
const ComponentLinkButton = (_a) => {
    var { id = '', title, href, className = '' } = _a, props = __rest(_a, ["id", "title", "href", "className"]);
    const [isLoading, toggleLoading] = useState(false);
    const iconStyle = { opacity: isLoading ? 1 : 0 };
    const textStyle = { opacity: isLoading ? 0 : 1 };
    const onClick = (event) => {
        event.preventDefault();
        if (isLoading) {
            return;
        }
        toggleLoading(true);
        window.location.href = href;
    };
    return (_jsxs("a", Object.assign({ id: id, href: href, className: `button ${className}`, onClick: onClick }, props, { children: [_jsx("span", Object.assign({ className: 'button--spinner' }, { children: _jsx("i", { className: 'fas fa-spinner-third fa-spin', style: iconStyle }) })), _jsx("span", Object.assign({ style: textStyle }, { children: title }))] })));
};
ComponentLinkButton.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    className: PropTypes.string
};
export default ComponentLinkButton;
